import React from 'react'
import SecondBanner from '../components/Banner/SecondBanner'

const contant = () => {
    return (
        <>
            <SecondBanner title="Contact Us" breadcrumbText="Contact" />
            <div class="container-fluid overflow-hidden py-5 px-lg-0">
                <div class="container contact-page py-5 px-lg-0">
                    <div class="row g-5 mx-lg-0">
                        <div class="col-md-6 contact-form wow fadeIn" data-wow-delay="0.1s">
                            <h6 class="text-secondary text-uppercase">Get In Touch</h6>
                            <h1 class="mb-4">Contact For Any Query</h1>
                            <p class="mb-4">Get customized industrial solutions tailored to your needs. From high-quality tools to complete workshop solutions, we provide top-notch products at competitive prices with timely delivery. Reach out today for a personalized quote!</p>
                            <div class="bg-light p-4">
                                <form>
                                    <div class="row g-3">
                                        <div class="col-md-6">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" id="name" placeholder="Your Name" />
                                                <label for="name">Your Name</label>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-floating">
                                                <input type="email" class="form-control" id="email" placeholder="Your Email" />
                                                <label for="email">Your Email</label>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" id="subject" placeholder="Subject" />
                                                <label for="subject">Subject</label>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-floating">
                                                <textarea class="form-control" placeholder="Leave a message here" id="message"></textarea>
                                                <label for="message">Message</label>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <button class="btn btn-primary w-100 py-3" type="submit">Send Message</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col-md-6 pe-lg-0 wow fadeInRight" data-wow-delay="0.1s">
                            <div class="position-relative h-100">
                                <iframe class="position-absolute w-100 h-100"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3499.8866712526!2d76.91919804999999!3d28.693036499999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d095611358d2f%3A0x4525a763340220db!2sSector%207%2C%20Bahadurgarh%2C%20Haryana%20124507!5e0!3m2!1sen!2sin!4v1757882985377!5m2!1sen!2sin"
                                    frameborder="0" allowfullscreen="" aria-hidden="false"
                                    tabindex="0"></iframe>



                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default contant